var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AudioElem"},[_c('audio',{ref:"audioElem",attrs:{"autoplay":"true","playsInline":"true","controls":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }